import React from 'react';

const Brushstroke = () => {
    return (
        <svg 
        className='brushstroke'
        width="300" 
        height="50"
        viewBox="0 0 484 80" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
            <path d="M62.0203 15.3509C176.229 33.6679 287.113 33.6991 393.116 6.88098" stroke="#FFD42A" strokeWidth="11.9779" strokeLinecap="round"/>
            <path d="M42.7706 30.3655C154.141 35.5261 229.779 55.6928 479.22 28.5544" stroke="#FFD42A" strokeWidth="8.39831" strokeLinecap="round"/>
            <path d="M42.0599 19.2379C235.775 37.5503 348.598 38.3225 433.54 20.3558" stroke="#FFD42A" strokeWidth="9.36205" strokeLinecap="round"/>
            <path d="M19.2859 44.2255L458.18 51.5403" stroke="#FFD42A" strokeWidth="9.77508" strokeLinecap="round"/>
            <path d="M18.9009 50.3854L450.095 60.0102" stroke="#FFD42A" strokeWidth="6.33315" strokeLinecap="round"/>
            <path d="M6.19605 65.4002L442.01 60.3953" stroke="#FFD42A" strokeWidth="7.15922" strokeLinecap="round"/>
            <path d="M19.3172 69.4178L450.064 58.3026" stroke="#FFD42A" strokeWidth="6.043" strokeLinecap="round"/>
            <path d="M45.8406 37.298L468.2 39.2181" stroke="#FFD42A" strokeWidth="7.03947" strokeLinecap="round"/>
            <path d="M43.1471 43.8425L465.23 45.5108" stroke="#FFD42A" strokeWidth="6.9959" strokeLinecap="round"/>
            <path d="M61.2872 26.8338C189.257 44.4658 297.666 38.8882 394.656 16.8907" stroke="#FFD42A" strokeWidth="7.15922" strokeLinecap="round"/>
            <path d="M20.8036 56.5925L455.163 57.6194" stroke="#FFD42A" strokeWidth="5.10454" strokeLinecap="round"/>
            <path d="M3.75397 60.165L456.008 65.1678" stroke="#FFD42A" strokeWidth="5.64477" strokeLinecap="round"/>
            <path d="M77.5069 22.3274C271.222 40.6398 372.555 39.1392 457.497 21.1725" stroke="#FFD42A" strokeWidth="9.36205" strokeLinecap="round"/>
            <path d="M19.3027 75.5921C163.114 70.4486 305.457 69.545 444.9 64.4481" stroke="#FFD42A" strokeWidth="6.01454" strokeLinecap="round"/>
            <path d="M13.126 64.7473C35.4056 80.203 208.883 79.3131 458.498 70.192" stroke="#FFD42A" strokeWidth="5.64477" strokeLinecap="round"/>
            <path d="M57.4187 23.835C191.15 41.3433 319.366 37.6498 420.722 15.8069" stroke="#FFD42A" strokeWidth="7.29287" strokeLinecap="round"/>
        </svg>
    )
}

export default Brushstroke;